import { CSSProperties } from "react";
import "./ServiceDetailHighlightBlockSection.css";
import {
  HighlightBlockItemTypes,
  ServiceDetailHighlightBlockSectionType,
} from "../../../utility/types/generaTypes";
type ServiceDetailHighlightBlockSectionProps = {
  style?: CSSProperties;
  highlightBlockSection: ServiceDetailHighlightBlockSectionType;
};
const ServiceDetailHighlightBlockSection = ({
  style,
  highlightBlockSection,
}: ServiceDetailHighlightBlockSectionProps) => {
  return (
    <section style={style}>
      <div className="app_section">
        <div className="appSection_header_container">
          <h1 className="section_title">{highlightBlockSection.title}</h1>
          <p className="section_description">
            {highlightBlockSection.description}
          </p>
        </div>

        <div className="highlightBlockCards_container">
          {highlightBlockSection.data.map((highlightBlock, index) => (
            <HighlightBlockCard
              key={"HighlightBlockCard" + index}
              highlightBlock={highlightBlock}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

type HighlightBlockCardProps = {
  highlightBlock: HighlightBlockItemTypes;
};

const HighlightBlockCard = ({ highlightBlock }: HighlightBlockCardProps) => {
  return (
    <div className="highlightBlockCard_container">
      <h2>{highlightBlock.count}</h2>
      <h3>{highlightBlock.title}</h3>
      <p>{highlightBlock.description}</p>
    </div>
  );
};

export default ServiceDetailHighlightBlockSection;
